export default function auth({next, store}) {
  if (!store.getters['auth/isUserLoggedIn']) {
    return next({name: 'login'});
  }

  return next();
}
